import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";


export interface DownloadUploadedDniResult {
  url: string | null;
  error: string | null;
}

export interface DownloadUploadedDniQueryParams {
  user_id: number;
  company_id: number;
}

export class DownloadUploadedDniQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher
  ) { }

  async run(params: DownloadUploadedDniQueryParams): Promise<DownloadUploadedDniResult> {
    const args = {
      user_id: params.user_id,
      company_id: params.company_id
    }

    const res = await this.dispatcher.dispatch('download.uploaded.representation.dni', args);
    return res as DownloadUploadedDniResult;
  }
}